import {usePermissions} from '@/hooks/usePermissions';
import {Box, CircularProgress} from '@mui/material';
import {useTranslation} from "react-i18next";

interface WithPermissionProps {
    children: React.ReactNode;
    permission: string | string[];
    fallback?: React.ReactNode;
    requireAll?: boolean;
    loadingComponent?: React.ReactNode;
}

export const WithPermission: React.FC<WithPermissionProps> = (
  {
      children,
      permission,
      fallback = null,
      requireAll = false,
      loadingComponent,
  }) => {
    const {t} = useTranslation();
    const {hasPermission, hasAllPermissions, isLoading} = usePermissions();

    if (isLoading) {
        if (!loadingComponent) {
            return <Box sx={{display: "flex", gap: 2, alignItems: "center", p: 2}}>
                <CircularProgress size={40}/> {t("Loading...")}
            </Box>;
        }

        return <>{loadingComponent}</>;
    }

    let hasAccess: boolean;

    if (requireAll && Array.isArray(permission)) {
        hasAccess = hasAllPermissions(permission);
    } else {
        hasAccess = hasPermission(permission);
    }

    if (!hasAccess) {
        return <>{fallback}</>;
    }

    return <>{children}</>;
};
